import VCheckbox from './VCheckbox';
import VSimpleCheckbox from './VSimpleCheckbox';
export { VCheckbox, VSimpleCheckbox };
export default {
  $_vuetify_subcomponents: {
    VCheckbox,
    VSimpleCheckbox
  }
};
//# sourceMappingURL=index.js.map